import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import { IHistoryProgress, describeHistoryNeeded } from '@innerhive-internal/innerhive-common';
import { BRAND, CHART_INK } from './agencyChartTheme';

const useStyles = createUseStyles({
    // Stands where the chart would be, so it takes enough of the card that the panel keeps its weight.
    empty: {
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        minHeight: 140,
        padding: '18px 16px',
        textAlign: 'center' as const
    },

    title: {
        fontSize: 15.5,
        fontWeight: 600,
        color: BRAND.deepTeal
    },

    detail: {
        maxWidth: 440,
        fontSize: 12.5,
        lineHeight: 1.5,
        color: CHART_INK.label
    }
});

/** A panel's figures once the caseload has the history they compare against, and until then what it is waiting for. */
export const NeedsHistory: FC<{
    history: IHistoryProgress;
    /** Which panel this stands in for, so a driver can select one without counting from the top. */
    panel: string;
    children: ReactNode;
}> = ({ history, panel, children }) => {
    const classes = useStyles();

    if (history.hasEnough) {
        return <>{children}</>;
    }

    return (
        <div className={classes.empty} data-id={`insights-pending-${panel}`}>
            <div className={classes.title}>Not Enough Data Yet</div>
            <div className={classes.detail}>{describeHistoryNeeded(history)}</div>
        </div>
    );
};
